import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'reactstrap';

const TagInput = ({ value = '', onChange, placeholder = 'Digite e pressione Enter', disabled = false }) => {
    const [tags, setTags] = useState(value ? value.split(';').filter(t => t.trim()) : []);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        setTags(value ? value.split(';').filter(t => t.trim()) : []);
    }, [value]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const trimmedValue = inputValue.trim();

            if (trimmedValue && !tags.includes(trimmedValue)) {
                const newTags = [...tags, trimmedValue];
                setTags(newTags);
                setInputValue('');
                if (onChange) {
                    onChange(newTags.join(';'));
                }
            }
        }
    };

    const removeTag = (indexToRemove) => {
        const newTags = tags.filter((_, index) => index !== indexToRemove);
        setTags(newTags);
        if (onChange) {
            onChange(newTags.join(';'));
        }
    };

    return (
        <div
            className="form-control d-flex flex-wrap align-items-center justify-items-center gap-4"
            style={{ minHeight: '42px', cursor: 'text' }}
            onClick={() => inputRef.current?.focus()}
        >
            {tags.map((tag, index) => (
                <span
                    key={index}
                    className="align-items-center position-relative mr-2"
                    style={{
                        fontSize: '14px',
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        paddingLeft: '14px',
                        paddingRight: '36px',
                        background: "#34b5b8",
                        color: "white",
                        borderRadius: "5px"
                    }}
                >
                    <span>{tag}</span>
                    {!disabled && (
                        <Button
                            type="button"
                            color="danger"
                            onClick={() => removeTag(index)}
                            aria-label="Remove tag"
                            className="rounded-circle position-absolute d-flex align-items-center justify-content-center p-0"
                            style={{
                                width: '20px',
                                height: '20px',
                                top: '-10px',
                                right: '-6px',
                                fontSize: '18px',
                                lineHeight: '1',
                                border: 'none'
                            }}
                        >
                            ×
                        </Button>
                    )}
                </span>
            ))}
            <input
                ref={inputRef}
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={tags.length === 0 ? placeholder : ''}
                disabled={disabled}
                className="border-0"
                style={{ outline: 'none', minWidth: '320px' }}
            />
        </div>
    );
};

export default TagInput;
